/** Shared prose-renderer className for chat/conversation message bubbles.
 * Wraps long words/headings, scrolls long <pre> blocks horizontally.
 */
export const CHAT_MARKDOWN_PROSE_CLASS =
  "prose prose-sm max-w-none break-words [overflow-wrap:anywhere] [&_pre]:overflow-x-auto [&_pre]:max-w-full [&_code]:break-words [&_h1]:break-words [&_h2]:break-words [&_h3]:break-words"
